export default __webpack_public_path__ + "static/media/Commander's Boots of Heaven's Pass.dd1c822b.jpg";